import { useContext } from 'react'
import WorkorderContext, { IWorkorderContextExpose } from 'contexts/WorkorderContext/WorkorderContext'

export const useWorkorderContext = (): IWorkorderContextExpose => {
  const v = useContext(WorkorderContext)
  if (!v.hasBeenProvided) {
    console.error('useWorkorderContext must be used within an WorkorderContextProvider')
  }

  return v
}
